import { Room } from "./../../models/room";
import { Room as LiveKitRoom} from 'livekit-client';
import { useCallback, useState } from "react";

const useRoom = ( token, url, handleSetParticipant, handleSyncAfterConnect) =>{

    const [isLoading] = useState(false);

    const handleConnectCall = useCallback(async ()=>{
        try{
            const roomDetails = new LiveKitRoom({
                adaptiveStream: true,
                dynacast: true
            });

            Room.getInstance().updateRoomInstance(roomDetails);

            // Register listeners BEFORE connect so ParticipantConnected fires
            // for participants already in the room during the connection handshake
            handleSetParticipant({
                webUrl : url,
                token : token,
                room : roomDetails
            });

            await roomDetails.connect(url, token);

            // Sync local participant + existing remote participants AFTER connect
            handleSyncAfterConnect(roomDetails);

            await roomDetails.localParticipant.setMicrophoneEnabled(true);
        }
        catch(e){
            console.log('ERROR IS AS FOLLOWS : ',e);
        }

    },[url, token, handleSetParticipant, handleSyncAfterConnect]);



    const handleGetActiveRoom = useCallback(async ()=>{

        if(isLoading){
            return;
        }

        await handleConnectCall();
    },[isLoading, handleConnectCall]);

    return {
        room : Room.getInstance().getRoom(),
        handleGetActiveRoom,
        handleConnectCall
    }
}

export {
    useRoom
}
